import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TokenAuth, UserDTO } from 'src/dto/users/users-dto';
import { decryptToObject } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const currentUser: TokenAuth = JSON.parse(decryptToObject(localStorage.getItem('CurrentUser')));
    if (currentUser != null) {
      const expectedRoles = route.data['expectedRoles'];
      if (!currentUser || !expectedRoles || !currentUser.roles.some(role => expectedRoles.includes(role))) {
        this.router.navigate(['/access-denied']);
        return false;
      }
      return true;
    } else {
      this.router.navigate(['/access-denied']);
      return false;
    }
  }
}
